
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import listado from './listados/listado-publicaciones.vue';
    import excelofertas from './listados/listado-excel-ofertas.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            listado,
            excelofertas,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;

        public Abierto: boolean = false;
        public Listados: { Nombre: string; Accion: Function; }[] = [
            { Nombre: 'Listado de publicaciones', Accion: () => this.AbrirListado( 'publicaciones' ) },
            { Nombre: 'Excel de ofertas', Accion: () => this.AbrirListado( 'excel-ofertas') },
        ];

        public Listado: string = '';
        AbrirListado(x: string )
        {
            this.Listado = '';
            this.$nextTick( () => this.Listado = x )
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            await this.Iniciar();
        }

        async Iniciar()
        {
        }

    }
